import { render, staticRenderFns } from "./AdminHistoryEdit.vue?vue&type=template&id=699bba86&"
import script from "./AdminHistoryEdit.vue?vue&type=script&lang=js&"
export * from "./AdminHistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports